var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-component',{attrs:{"url":"projects_other","entity-name":"project_other","entity-title":"Проекты НДС и ВП","parent-url":[
    { to: '/projects_other', text: 'Проекты НДС и ВП'}
  ],"tabs":[
    ['', 'Основное', 0],
    ['discussion', 'Обсуждение', 0],
    ['map', 'Карта работ', 0]
  ]}})}
var staticRenderFns = []

export { render, staticRenderFns }